//
//
//
//
//
//
//
//

import vHeader from 'views/layouts/header'
import vFooter from 'views/layouts/footer'
export default {
  name: 'App',
  components: {
    vHeader,
    vFooter
  }
}



// WEBPACK FOOTER //
// ./src/App.vue